import { useRecoilValue } from "recoil";

import BetDetailsProfitBoost from "src/components/betBlock/components/boostPercent";
import BetDetailsTaxOnReturnOrProfit from "../taxOnReturnOrProfit";
import BetDetailsEstimatedReturn from "../estimatedReturn";
import BetDetailsStakeWithoutTax from "../stakeWithoutTax";
import BetDetailsMinPossibleWin from "../minPossibleWin";
import BetDetailsPossibleWin from "../possibleWin";
import BetDetailsTaxOnStake from "../taxOnStake";
import BetDetailsTotalStake from "../totalStake";
import BetDetailsTotalWin from "../totalWin";
import BetDetailsTotalOdd from "../totalOdd";
import { useConfig } from "src/hooks/config";
import mainStore from "src/stores/main";
import BetDetailsBonus from "../bonus";

import "./style.scss";

interface IProps {
	stake: number;
}

const configAliasesComponentMap = {
	estimated_return: BetDetailsEstimatedReturn,
	tax_on_stake: BetDetailsTaxOnStake,
	total_odd: BetDetailsTotalOdd,
	total_stake: BetDetailsTotalStake,
	possible_win: BetDetailsPossibleWin,
	bonus: BetDetailsBonus,
	tax_on_return_or_profit: BetDetailsTaxOnReturnOrProfit,
	total_win: BetDetailsTotalWin,
	min_possible_win: BetDetailsMinPossibleWin,
	stake_without_tax: BetDetailsStakeWithoutTax,
	profit_boost: BetDetailsProfitBoost,
};

const BetDetails = ({ stake }: IProps) => {
	const config = useConfig();
	const { isEachWay } = useRecoilValue(mainStore);
	const finalStake = isEachWay ? stake * 2 : stake;

	return (
		<>
			{config.betDetailsOrder.map(alias => {
				const Component = configAliasesComponentMap[alias];
				return <Component key={alias} stake={finalStake} />;
			})}
		</>
	);
};

export default BetDetails;
